import React, { Component } from "react";
import { PageHeader, Tag, notification, Space, Typography, Tabs, InputNumber, Form } from "antd";
import { PlusOutlined, EditOutlined, StopOutlined, CheckCircleOutlined, FormOutlined, CopyOutlined, BarChartOutlined } from "@ant-design/icons";
import { ButtonItem, SegmentedItem, TableItemDinamico } from "../../../../Components/Items";
import { tabStyles } from "../../../../Components/TabbedDynamicTable";
import axios from "axios";
import { connect } from "react-redux";

const { Text } = Typography;

class ConfiguracionEvaluacionProveedores extends Component {
  tableRef = null;

  state = {
    plantillas: [],
    loading: false,
    totalRecords: 0,
    valorFiltro: 1, // 1: Activas, 0: Inactivas, 2: Todas
    objetivoMensual: 73,
    guardandoObjetivo: false,
  };

  componentDidMount() {
    this.cargarObjetivo();
  }

  cargarObjetivo = () => {
    axios
      .post(
        "empresas/selectConfiguracionEvaluacionProveedores",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ objetivoMensual: res.data.configuracionEvaluacionProveedores.objetivoMensual });
        }
      })
      .catch(() => notification.error({ message: "Error al cargar el objetivo del indicador." }));
  };

  guardarObjetivo = () => {
    this.setState({ guardandoObjetivo: true });
    axios
      .post(
        "empresas/editarConfiguracionEvaluacionProveedores",
        { empresaId: this.props.empresaId, objetivoMensual: this.state.objetivoMensual },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          notification.success({ message: res.data.message });
        } else {
          notification.error({ message: res.data.message });
        }
      })
      .catch(() => notification.error({ message: "Error al guardar el objetivo." }))
      .finally(() => this.setState({ guardandoObjetivo: false }));
  };

  fetchData = (params) => {
    this.setState({ loading: true });
    axios
      .post(
        "plantillasEvaluacion/selectPlantillas",
        { ...params, empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ plantillas: res.data.data, totalRecords: res.data.totalRecords });
        } else {
          notification.error({ message: "Error", description: res.data.message });
        }
      })
      .catch(() => {
        notification.error({ message: "Error de conexión al cargar las plantillas." });
      })
      .finally(() => this.setState({ loading: false }));
  };

  crearPlantilla = () => {
    this.props.history.push("/panel/evaluacionProveedoresConfiguracion/plantilla/nuevo");
  };

  editarPlantilla = (id) => {
    this.props.history.push(`/panel/evaluacionProveedoresConfiguracion/plantilla/${id}`);
  };

  toggleEstado = (plantilla) => {
    const nuevoEstado = plantilla.estado ? 0 : 1;
    axios
      .post(
        "plantillasEvaluacion/cambiarEstadoPlantilla",
        { _id: plantilla._id, estado: nuevoEstado },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState((prev) => ({
            plantillas: prev.plantillas.map((p) =>
              p._id === plantilla._id ? { ...p, estado: nuevoEstado } : p,
            ),
          }));
          notification.success({ message: res.data.message });
        } else {
          notification.error({ message: res.data.message });
        }
      })
      .catch(() => notification.error({ message: "Error al cambiar el estado." }));
  };

  atras = () => {
    this.props.history.goBack();
  };

  render() {
    const columnas = [
      {
        title: "Nombre",
        dataIndex: "nombre",
        buscar: "nombre",
        render: (text, record) => (
          <Text strong style={{ color: record.estado ? "#172b4d" : "#a5adba" }}>
            {text}
          </Text>
        ),
      },
      {
        title: "Versión",
        dataIndex: "versionNumero",
        width: 140,
        render: (v, record) => (
          <Tag color="blue">
            v{v}
            {record.versionEtiqueta ? ` - ${record.versionEtiqueta}` : ""}
          </Tag>
        ),
      },
      {
        title: "Secciones",
        dataIndex: "secciones",
        width: 110,
        render: (secciones) => <Tag>{secciones?.length || 0} secciones</Tag>,
      },
      {
        title: "Autorización",
        dataIndex: "autorizado",
        width: 130,
        render: (autorizado) =>
          autorizado ? <Tag color="green">Autorizada</Tag> : <Tag color="orange">Borrador</Tag>,
      },
      {
        title: "Estado",
        dataIndex: "estado",
        width: 100,
        render: (estado) => (estado ? <Tag color="green">Activa</Tag> : <Tag color="red">Inactiva</Tag>),
      },
      {
        title: "Acciones",
        dataIndex: "acciones",
        width: 150,
        render: (text, record) => (
          <Space>
            <ButtonItem
              disabled={!this.props.permisoConfigurarPlantillas}
              size="small"
              icon={record.autorizado ? <CopyOutlined /> : <EditOutlined />}
              onClick={() => this.editarPlantilla(record._id)}
              tooltip={record.autorizado ? "Ver / Clonar" : "Editar"}
            />
            <ButtonItem
              disabled={!this.props.permisoConfigurarPlantillas}
              rojo={record.estado}
              verde={!record.estado}
              size="small"
              icon={record.estado ? <StopOutlined /> : <CheckCircleOutlined />}
              onClick={() => this.toggleEstado(record)}
              tooltip={record.estado ? "Deshabilitar" : "Habilitar"}
            />
          </Space>
        ),
      },
    ];

    return (
      <div style={{ padding: "0 20px" }}>
        <PageHeader
          title="Configuración de Evaluación de Proveedores"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 15,
          }}
          onBack={this.atras}
        />

        <style>{tabStyles}</style>
        <div
          style={{
            backgroundColor: "#ffffff",
            borderRadius: 12,
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            overflow: "hidden",
            padding: 20,
          }}
        >
          <Tabs defaultActiveKey="plantillas" className="custom-tabs">
            <Tabs.TabPane
              key="plantillas"
              tab={
                <span style={{ color: "#1a3a4a", fontWeight: 600, fontSize: 14 }}>
                  <FormOutlined style={{ marginRight: 6 }} />
                  Plantillas
                </span>
              }
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 10,
                  alignItems: "center",
                  marginBottom: 12,
                }}
              >
                <SegmentedItem
                  options={[
                    { label: "Activas", value: 1 },
                    { label: "Inactivas", value: 0 },
                    { label: "Autorizadas", value: "autorizadas" },
                    { label: "Todas", value: 2 },
                  ]}
                  onChange={(value) => {
                    if (this.tableRef) {
                      this.tableRef.updateExternalFilters(
                        value === "autorizadas"
                          ? { estado: 2, autorizado: true }
                          : { estado: value },
                      );
                    }
                    this.setState({ valorFiltro: value });
                  }}
                  value={this.state.valorFiltro}
                />
                <div style={{ borderLeft: "1px solid #d9d9d9", height: 24, margin: "0 5px" }} />
                <ButtonItem
                  azul
                  disabled={!this.props.permisoConfigurarPlantillas}
                  icon={<PlusOutlined />}
                  className="botonAgregar"
                  onClick={this.crearPlantilla}
                >
                  Nueva Plantilla
                </ButtonItem>
              </div>

              <TableItemDinamico
                onRef={(node) => (this.tableRef = node)}
                columns={columnas}
                dataSource={this.state.plantillas}
                loading={this.state.loading}
                totalRecords={this.state.totalRecords}
                onFetchData={this.fetchData}
                rowKey="_id"
              />
            </Tabs.TabPane>

            <Tabs.TabPane
              key="indicador"
              tab={
                <span style={{ color: "#1a3a4a", fontWeight: 600, fontSize: 14 }}>
                  <BarChartOutlined style={{ marginRight: 6 }} />
                  Indicador
                </span>
              }
            >
              <Form layout="vertical" style={{ maxWidth: 320 }}>
                <Form.Item
                  label="Objetivo mensual del indicador (%)"
                  extra="Calificación promedio mínima esperada cada mes. Se usa como línea de meta en el reporte."
                >
                  <InputNumber
                    min={0}
                    max={100}
                    disabled={!this.props.permisoConfigurarPlantillas}
                    value={this.state.objetivoMensual}
                    onChange={(objetivoMensual) => this.setState({ objetivoMensual })}
                    style={{ width: 120 }}
                  />
                </Form.Item>
                <ButtonItem
                  azul
                  disabled={!this.props.permisoConfigurarPlantillas}
                  loading={this.state.guardandoObjetivo}
                  onClick={this.guardarObjetivo}
                >
                  Guardar objetivo
                </ButtonItem>
              </Form>
            </Tabs.TabPane>
          </Tabs>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  permisoConfigurarPlantillas:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (v) => v.permisoId.toString() === "6a726d3e84bfe1e26a3e4c6a",
    )?.activado,
});

export default connect(mapStateToProps)(ConfiguracionEvaluacionProveedores);
